var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClinicAdminReportIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.222 13.667a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.555 12.555a1.11 1.11 0 1 0 0 2.222 1.11 1.11 0 0 0 0-2.222m-2.222 1.112a2.222 2.222 0 1 1 4.444 0 2.222 2.222 0 0 1-4.444 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.111 19.424c0-1.612 2.961-2.424 4.445-2.424 1.483 0 4.444.812 4.444 2.424V22h-8.889z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.386 19.148c-.157.159-.164.245-.164.276v1.465h6.667v-1.465c0-.03-.005-.117-.163-.276-.167-.168-.447-.352-.837-.522-.784-.344-1.744-.515-2.333-.515s-1.55.172-2.334.515c-.389.17-.669.354-.836.522M17.556 17c-1.484 0-4.445.812-4.445 2.424V22h8.89v-2.576C22 17.812 19.038 17 17.555 17",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7 19.778c0 .298.1.578.276.776.167.189.43.335.835.335h5.555V22H8.111c-.706 0-1.277-.27-1.665-.707a2.28 2.28 0 0 1-.557-1.515V17h1.11z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m6.444 15.659 3.171 3.17-.786.786-2.385-2.385-2.385 2.385-.785-.786zM4.778 3.11A1.11 1.11 0 0 1 5.888 2h4.445a1.11 1.11 0 0 1 1.111 1.111v.556h2.778v10.555H2V3.667h2.778zm0 1.667H3.11v1.11h1.667zm0 2.222H3.11v6.111H5.89V9.778h4.444v3.333h2.778V7h-1.667v.556a1.11 1.11 0 0 1-1.11 1.11H5.888a1.11 1.11 0 0 1-1.111-1.11zm6.666-1.111h1.667V4.778h-1.667zM9.222 13.11V10.89H7v2.222zM7.556 4.778V3.11h1.11v1.667h1.667v1.11H8.667v1.668H7.556V5.889H5.889V4.778z",
  clipRule: "evenodd"
})));
export { SvgClinicAdminReportIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/clinicAdminReportIcon.svg";